'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _home = require('./remote/home');

exports.default = {
    fetchHomeData: _home.HomeRemote.fetchHomeData
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/home.js
// module id = IWsF
// module chunks = 57